var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick2Amber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "42721316-43A8-472E-AC28-6CE17AF70540") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.-Question-time-Q1---answers-UI",
    transform: "translate(-760.000000, -280.000000)",
    fill: "#DF6532",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(352.000000, 257.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-2",
    transform: "translate(408.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0320061,4.00019026 C27.6069543,3.56728294 26.9172891,3.56653705 26.4922373,3.99835421 L13.4284404,17.245605 L8.71506058,12.040791 C8.30778511,11.5913018 7.61919215,11.5621545 7.17636401,11.9761848 C6.73387447,12.3902726 6.70554521,13.0907275 7.11282069,13.5406184 L12.5939123,19.5927717 C12.7946437,19.81459 13.0755662,19.9434008 13.3717819,19.9496548 C13.3797389,19.9499991 13.3874138,19.9499991 13.3950322,19.9499991 C13.6828959,19.9499991 13.9598116,19.8337539 14.1638162,19.6270829 L28.0298616,5.5660582 C28.4559856,5.13429842 28.4567193,4.43309758 28.0320061,4.00019026 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7867158,13.3492164 C27.1856421,13.3492164 26.6984893,13.8363692 26.6984893,14.4374993 C26.6984893,21.1984788 21.1984788,26.6984893 14.4374993,26.6984893 C7.67691469,26.6984893 2.17650942,21.1984788 2.17650942,14.4374993 C2.17650942,7.67691469 7.67691469,2.17650942 14.4374993,2.17650942 C15.038573,2.17650942 15.5257823,1.68935661 15.5257823,1.08828291 C15.5257823,0.48715281 15.038573,0 14.4374993,0 C6.47657197,0 0,6.47657197 0,14.4374993 C0,22.3980883 6.47657197,28.8749987 14.4374993,28.8749987 C22.3980883,28.8749987 28.8749987,22.3980883 28.8749987,14.4374993 C28.8749987,13.8364256 28.3878459,13.3492164 27.7867158,13.3492164 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick2Amber);
export default __webpack_public_path__ + "static/media/tick-2-amber.3433a5a9.svg";
export { ForwardRef as ReactComponent };